import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import {createDataTestId} from '../../utils/dataTestId';

type Props = {
    width?: number;
    height?: number;
};

const defaultSize = 60;

export const AILoader = (props: Props) => {
    const {width = defaultSize, height = defaultSize} = props;

    return (
        <div className={styles.loader} style={{width, height}} {...createDataTestId('loader')}>
            <svg
                className={cx(styles.twinkle, styles.star1)}
                viewBox="0 0 512 512"
                width={width}
                height={height}
            >
                <path d="M256 0C275 170 342 237 512 256C342 275 275 342 256 512C237 342 170 275 0 256C170 237 237 170 256 0Z" />
            </svg>

            <svg
                className={cx(styles.twinkle, styles.star2)}
                viewBox="0 0 512 512"
                width={width / 2}
                height={height / 2}
                fill="#9e42ff"
            >
                <path d="M256 0C275 170 342 237 512 256C342 275 275 342 256 512C237 342 170 275 0 256C170 237 237 170 256 0Z" />
            </svg>
        </div>
    );
};
